import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewport } from '../getViewport';

export const storyChat = () => {
  const storyChat = $('.story-chat');

  if (storyChat) {
    gsap.set(storyChat, { y: viewport.isReduced ? 0 : 200 });
    const timeline = gsap.timeline();
    timeline.to(storyChat, { y: 0 });

    ScrollTrigger.create({
      animation: timeline,
      trigger: storyChat,
      start: () => 'top bottom',
      end: () => 'top center',
      toggleActions: 'play pause resume reset',
      scrub: 1,
    });

    const chatHeadlines = $$('.story-chat__chat-item > h5');

    chatHeadlines.forEach(headline => {
      gsap.set(headline, {
        x: viewport.isReduced
          ? 0
          : viewport.isDesktop
          ? -30
          : viewport.isTablet
          ? -30
          : viewport.isMobile
          ? -15
          : '',
      });
      const timeline = gsap.timeline();
      timeline.to(headline, { x: 0 });

      ScrollTrigger.create({
        animation: timeline,
        trigger: headline,
        start: () => 'top bottom',
        end: () => 'top center',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });

    const chatQuotes = $$('.story-chat__chat-item > blockquote');

    chatQuotes.forEach(quote => {
      gsap.set(quote, {
        x: viewport.isReduced
          ? 0
          : viewport.isDesktop
          ? 30
          : viewport.isTablet
          ? 30
          : viewport.isMobile
          ? 15
          : '',
      });
      const timeline = gsap.timeline();
      timeline.to(quote, { x: 0 });

      ScrollTrigger.create({
        animation: timeline,
        trigger: quote,
        start: () => 'top bottom',
        end: () => 'top center',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });
  }
};
